import React from 'react';
// import SarasDnDCard from '../../../../library/hooks/bdnd/SarasDnDCard';
import SarasDnDCard from '../../../../library/hooks/dndkit/SarasDnDCard';
import calViewMap from '../Index';

const CalPlanItem = ({ rowKey, index, viewData, calendarControl, isSortMode, isTabletWidthOrLess, onMoveDate }) => {
    const viewKey = viewData?.viewKey || '';
    const DynamicComponent = viewKey ? calViewMap[viewKey] : null;
    const displayMode = calendarControl?.getSetting
        ? calendarControl.getSetting('displayMode', 'mini')
        : 'mini';
    const photoCardStyle = displayMode === 'photo'
        ? { width: '50%', display: 'block' }
        : undefined;
    const itemClass = displayMode === 'photo' ? 'uiCalPlanItem uiCalPlanItemPhoto' : 'uiCalPlanItem uiCalPlanItemMini';

    // console.log('dndkit calendar plan item render', rowKey, index, isSortMode);

    return (
        <SarasDnDCard rowKey={rowKey} index={index} isSortMode={isSortMode} cardStyle={photoCardStyle}>
            <li className={itemClass}>
                <div className="uiCalPlanItemInner">
                    {DynamicComponent ? (
                        <DynamicComponent
                            viewData={viewData}
                            rowKey={rowKey}
                            calendarControl={calendarControl}
                            isTabletWidthOrLess={isTabletWidthOrLess}
                            onMoveDate={onMoveDate}
                        />
                    ) : (
                        <div style={{ fontWeight: 700, color: '#31435d' }}>
                            {rowKey}
                        </div>
                    )}
                </div>
            </li>
        </SarasDnDCard>
    );
};

export default CalPlanItem;
